export const getOptions = (min, max) => {
    const optionList = [];
    if (min > max) {
        optionList.push({
            label: min,
            value: min
        });
    }
    else {
        for (let i = min; i <= max; i++) {
            optionList.push({
                label: i,
                value: i
            });
        }
    }
    return optionList;
};
export const getBgControl = (type, bgControlCom, bgControlBg) => {
    let bgControl = {type: ''};
    if (type === 'combination') {
        bgControl = bgControlCom;
    }
    else if (type === 'background') {
        bgControl = bgControlBg;
    }
    return bgControl;
};

// 不同模式下，使用不同变量
export const getSizeControl = (type, data) => {
    if (type === 'background' && data.sizeControlBg) {
        return data.sizeControlBg;
    }
    return data.sizeControl;
};

// 不同模式下，使用不同变量
export const getMainPart = (type, data) => {
    if (type === 'combination' && data.mainPartCombine) {
        return data.mainPartCombine;
    }
    return data.mainPart;
};

export const getIntelTaregtStatus = (data, currentCount = 1) => {
    const {composition, bgControlCom, bgControlBg} = data;
    let count = currentCount;
    let isSingleOption = false;
    const type = composition.type;
    const bgControl = getBgControl(type, bgControlCom, bgControlBg);
    const isBgControlGenerateOrBgStyle = ['generate', 'bgStyle'].includes(bgControl.type);

    const mainPart = getMainPart(type, data);

    if (type === 'combination') {
        if (mainPart.type === 'generate' && isBgControlGenerateOrBgStyle) {
            // count = 1;
        }
        else if (mainPart.type === 'generate' && bgControl.type === 'choose') {
            count = bgControl.value.colorList.length || 1;
            isSingleOption = true;
        }
        else if (mainPart.type === 'choose' && isBgControlGenerateOrBgStyle) {
            count = mainPart.value.chooseList.length || 1;
        }
        else if (mainPart.type === 'custom' && isBgControlGenerateOrBgStyle) {
            count = mainPart.value.uploadList.length || 1;
        }
        else if (mainPart.type === 'custom' && bgControl.type === 'choose') {
            count = (mainPart.value.uploadList.length || 1) * (bgControl.value.colorList.length || 1);
            isSingleOption = true;
        }
        else if (mainPart.type === 'choose' && bgControl.type === 'choose') {
            count = (mainPart.value.chooseList.length || 1) * (bgControl.value.colorList.length || 1);
            isSingleOption = true;
        }
    }
    else if (type === 'background') {
        if (isBgControlGenerateOrBgStyle) {
            count = 4;
        }
        else if (bgControl.type === 'choose') {
            count = bgControl.value.colorList.length || 1;
            isSingleOption = true;
        }
    }
    else if (type === 'mainBody') {
        if (mainPart.type === 'generate') {
            // count = 1;
        }
        else if (mainPart.type === 'custom') {
            count = mainPart.value.uploadList.length || 1;
            isSingleOption = true;
        }
        else if (mainPart.type === 'choose') {
            count = mainPart.value.chooseList.length || 1;
            isSingleOption = true;
        }
    }
    return {count, isSingleOption};
};

export const getDesignTaregtStatus = (data, currentCount = 1) => {
    const {bgBase, templateDesign} = data;
    let count = currentCount;
    let isSingleOption = false;

    if (templateDesign.switch) {
        // 没选择模版的话，最少是底图数量、最大是9；选择模版的话，数量是底图与模版的乘积，不可改
        if (bgBase.type === 'upload' && templateDesign.type === 'intelligent') {
            count = bgBase.value.uploadUrl.length || 1;
        }
        else if (bgBase.type === 'quickUse' && templateDesign.type === 'intelligent') {
            count = bgBase.value.bringUrlList.length || 1;
        }
        else if (bgBase.type === 'upload' && templateDesign.type === 'choose') {
            count = templateDesign.value.chooseList.length || 1;
            isSingleOption = true;
        }
        else if (bgBase.type === 'quickUse' && templateDesign.type === 'choose') {
            count = (bgBase.value.bringUrlList.length || 1) * (templateDesign.value.chooseList.length || 1);
            isSingleOption = true;
        }
    }
    else {
        if (bgBase.type === 'upload') {
            count = bgBase.value.uploadUrl.length || 1;
        }
        else if (bgBase.type === 'quickUse') {
            count = bgBase.value.bringUrlList.length || 1;
        }
    }
    return {count, isSingleOption};
};

export const getIntelFormSubmitData = data => {
    const {
        composition,
        bgControlCom,
        bgControlBg
    } = data;
    const type = composition.type;
    let params = {};

    let logInfo = {
        composition: type
    };

    // 不同类型的表单不共用，需要正确赋值
    const mainPart = getMainPart(type, data);
    const sizeControl = getSizeControl(type, data);

    const getSizeParams = () => {
        let params = {width: 0, height: 0};
        if (sizeControl.type === 'choose') {
            sizeControl.value.ratio ? params.ratio = `RATIO_${sizeControl.value.ratio.replace(/:/g, '_')}` : '';
            const sizeList = sizeControl.value.dimension.split('*');
            params.width = +sizeList[0];
            params.height = +sizeList[1];

            logInfo.ratio = sizeControl.value.ratio;
        }
        else if (sizeControl.type === 'custom') {
            params.width = +sizeControl.value.customWidth;
            params.height = +sizeControl.value.customHeight;
        }
        params.ratioNum = params.height / params.width;

        logInfo.sizeType = sizeControl.type;
        logInfo.size = `${params.width}*${params.height}`;

        return params;
    };

    const getBackgroundParams = () => {
        let params = {backgroundPrompt: '', backgroundList: [], style: '', backgroundType: ''};
        const bgControl = getBgControl(type, bgControlCom, bgControlBg);

        if (bgControl.type === 'bgStyle') {
            params.style = bgControl.value.bgStyle;
        }
        if (bgControl.type === 'choose') {
            params.backgroundList = bgControl.value.colorList;
        }
        if (bgControl.type === 'generate') {
            params.backgroundPrompt = bgControl.value.prompt;
        }
        // if (bgStyle.switch) {
        //     params.style = bgStyle.value;
        // }
        params.backgroundType = bgControl.type === 'bgStyle' ? 'generate' : bgControl.type;

        logInfo.bgType = bgControl.type;

        return params;
    };

    const getMainBodyParams = () => {
        let params = {mainPartPrompt: '', mainPartList: [], mainPartType: ''};
        if (mainPart.type === 'generate') {
            params.mainPartPrompt = mainPart.value.prompt;
        }
        else if (mainPart.type === 'choose') {
            params.mainPartList = mainPart.value.chooseList;
        }
        else if (mainPart.type === 'custom') {
            params.mainPartList = mainPart.value.uploadList.map(i => i.url);
        }
        params.mainPartType = mainPart.type;

        logInfo.mainType = params.mainPartType;

        return params;
    };

    // 根据组合模式的布局和尺寸，结合size，计算组合里的主体大小和位置
    const sizeParams = getSizeParams();
    const getCombinationParams = () => {
        const {position, size} = composition.value;
        const {width, height} = sizeParams;

        logInfo.position = position;
        logInfo.mainSize = size;

        // 中间留一个方形，尺寸是短边的大小，计算方形内核区域的大小，宽度除以1.2，计算居中的坐标。
        // 偏向哪个边，则对应边的间距进行变化
        const base = height > width ? width : height;
        const standardHeight = base * 0.618;
        const standardWidth = standardHeight / 1.2;
        // 根据所选的主体大小，计算主体缩放比例，然后乘以标准宽高，得到实际宽高
        const scale = size > 2 ? 1.5 : (size < 2 ? 0.8 : 1);
        let fgH = standardHeight * scale;
        let fgW = standardWidth * scale;
        // 计算方形区域上、左的空间
        let spaceTop = (height - fgH) / 2;
        let spaceLeft = (width - fgW) / 2;
        let posX = spaceLeft;
        let posY = spaceTop;
        if (position === 'left') {
            posX *= 0.5;
        }
        else if (position === 'right') {
            posX *= 1.5;
        }
        else if (position === 'top') {
            posY *= 0.5;
        }
        else if (position === 'bottom') {
            posY *= 1.5;
        }
        let params = {
            fgH: Math.round(fgH),
            fgW: Math.round(fgW),
            posX: Math.round(posX),
            posY: Math.round(posY)
        };
        return params;
    };

    if (type === 'background') {
        params = {
            ...getSizeParams(),
            ...getBackgroundParams(),
            imageGenerateType: 'BACKGROUND'
        };
    }
    else if (type === 'mainBody') {
        params = {
            ...getMainBodyParams(),
            width: 500,
            height: 600,
            imageGenerateType: 'SUBJECT'
        };
    }
    else if (type === 'combination') {
        params = {
            ...getSizeParams(),
            ...getBackgroundParams(),
            ...getMainBodyParams(),
            ...getCombinationParams(),
            position: composition.value.position,
            size: composition.value.size,
            bgWeight: 0.2
        };
    };

    return {
        type, params,
        logInfo
    };
};

// 格式化高级设计表单的参数
export const getDesignFormSubmitData = (data = {}, formConfig = [], targetCount = 1) => {
    const {
        bgBase,
        industry,
        sizeControl,
        writing,
        templateDesign
    } = data;
    const templateType = templateDesign.type;
    let params = {
        imageGenerateType: 'MARKETING_IMAGE_MODEL',
        businessPoint: '',
        targetCount
    };
    let replaceLayerMap = {};
    // 根据底图的类型区分要替换的图层
    const bgBaseType = bgBase.type;
    const bgBaseValue = bgBase.value;
    let imgList = [];
    let needCutout = false;
    let position = '';
    // 组合 模式的布局也需要作为tag筛选模版
    if (bgBaseType === 'quickUse') {
        imgList = bgBaseValue.bringUrlList || [];
        const {bringComposition, bringCombination} = bgBaseValue;
        needCutout = bringComposition === 'mainBody';
        position = bringComposition === 'combination' ? bringCombination?.position : '';
        params.position = position;
    }
    else if (bgBaseType === 'upload' && bgBaseValue.onlySubject) {
        needCutout = true;
        imgList = bgBaseValue.uploadMainUrl || [];
    }
    else {
        imgList = bgBaseValue.uploadUrl || [];
    }

    // 如果是模版选择，则指定模版ID，多个逗号拼接；如果是智能设计，则需要根据参数组装查询模版的tag
    if (templateDesign.switch && templateType === 'choose') {
        params.name = templateDesign.value.chooseList.join(',');
    }
    else {
        // 抽成独立方法，模版选中的组件里也可以引用
        let ratio = sizeControl.value.ratio;
        let tags = getTemplateTags(needCutout, ratio, industry.value, position);
        params.tags = tags.join('&');
    }
    // 如果填写了文案，则需要带上文案的信息
    // 遍历formConfig，对type为textInput、visible是true的字段，data里对应的value不为空，则带上
    // 后端接口升级后，这里就可以去掉默认值了
    let posterJsonMatches = [{
        type: '主标题',
        name: ''
    }];
    // 没打开文案区域、或者没填的元素，把模版里自带的该文本元素给删掉，避免出来的文案与实际推广相差太大
    // if (writing.switch) {
        formConfig.forEach(item => {
            if ((item.type === 'textInput' || item.type === 'textInputCustom' || item.type === 'autoComplete')
                && data[item.name]
                // && data[item.name].value?.length > 0
            ) {
                const label = item.layerName || item.label;
                let value = data[item.name].value;
                if (item.visible && value.length > 0) {
                    posterJsonMatches.push({
                        type: label,
                        name: value
                    });
                }
                else {
                    // 如果隐藏状态，则此字段要清空
                    value = '';
                }
                // needClear字段，可以让部分元素在未填写的时候指定不需要清空模版里的元素文案，例如按钮文案之类的
                // 但如果是重复的元素，已经赋值了、对于未显示出来的、不能重复赋值
                // 对需要清空的元素 ，如果可视、非空值，也需要替换
                if ((item.needClear !== false && !(replaceLayerMap[label] != null && !item.visible))
                    || (item.needClear === false && item.visible && value !== '')
                ) {
                    replaceLayerMap[label] = {
                        label,
                        value,
                        type: 'span'
                    };
                }
            }
        });
    // }
    // 如果指定了模版ID查询，则不要带上元素匹配逻辑了
    if (posterJsonMatches.length > 0 && !params.name) {
        params.posterJsonMatches = posterJsonMatches;
    }
    // 旧版本营销图暂强制不展示LOGO图
    const label = 'LOGO图';
    replaceLayerMap[label] = {
        label,
        value: '',
        type: 'image'
    };
    // 把所有要替换的图片、文本都记录下来，后面使用
    params.replaceLayerMap = replaceLayerMap;
    params.replaceBaseList = imgList;

    // 指定图片尺寸
    const sizeList = sizeControl.value.dimension.split('*');
    params.width = +sizeList[0];
    params.height = +sizeList[1];
    params.needCutout = needCutout;
    params.ratioNum = params.height / params.width;


    params.logInfo = {
        tplSwitch: templateDesign.switch,
        write: writing.switch,
        tplType: templateType,
        cutout: needCutout,
        baseType: bgBaseType,
        sizeType: sizeControl.type,
        ratio: sizeControl.value.ratio,
        size: `${params.width}*${params.height}`,
        trade: industry.value
    };
    return params;
};

// 提交表单时，需记录下来的有用的参数，供日志分析使用
export const getSubmitLogData = (data, activeTab, targetCount) => {
    // 先得到表单格式化后的参数，然后只保留部分，拼成字符串返回
    let func = activeTab === 'intelForm' ? getIntelFormSubmitData : getDesignFormSubmitData;
    let formatData = typeof func === 'function' ? func(data) : {};
    let logInfo = formatData.logInfo || {};
    logInfo.targetCount = targetCount;
    let logString = '';
    for (let key in logInfo) {
        if (logInfo.hasOwnProperty(key)) {
            logString += `${key}=${logInfo[key]}&`;
        }
    }
    return logString;
};

const positionTagMap = {
    'left': '居左',
    'right': '居右',
    'center': '居中',
    'top': '居上',
    'bottom': '居下'
};

export function getTemplateTags(needCutout = false, ratio = '', industryValue = '', position = '') {
    let tags = [];
    // 给营销图模块单独的标签
    tags.push('擎舵营销图');
    /**
     * 查询模版的过滤标签：
     * 如果是主体、带“有抠图”；其他的，“无抠图”
     * 按照比例，拼接比例标签，例如：模版中心_1:1
     * 如果选了行业，带行业标签，如：INDUSTRY:9
     */
    if (needCutout) {
        tags.push('有抠图');
    }
    else {
        tags.push('不抠图');
    }
    if (ratio) {
        tags.push(`模版中心_${ratio}`);
    }

    // 行业，可能一个行业选项有多个值，逗号split、过滤、然后拼接
    if (industryValue) {
        // todo，此处待后续逻辑确定后可能需要升级：多个行业应该是&拼接其他tag、行业之间用|链接
        industryValue.split(',').filter(str => str).forEach(id => {
            tags.push(`INDUSTRY:${id}`);
        });
    }
    // 布局
    if (positionTagMap[position]) {
        tags.push(`布局_${positionTagMap[position]}`);
    }
    return tags;
}